import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby'
import parser from 'html-react-parser'

export default function ContentBlocks2({ data }) {
    const { contentBlocks2Block1ButtonText, contentBlocks2Block1Subtitle, contentBlocks2Block1ButtonLink, contentBlocks2Block1Text, contentBlocks2Block1Title, contentBlocks2Block2ButtonLink, contentBlocks2Block2ButtonText, contentBlocks2Block2Text, contentBlocks2Block2Title, contentBlocks2Block3ButtonText, contentBlocks2Block3Text, contentBlocks2Block3Title, contentBlocks2Block4Text, contentBlocks2Block4Title, contentBlocks2Title, contentBlocks2Text, contentBlocks2Block3ButtonLink, contentBlocks2Blocks, contentBlocks2Block1ButtonExternalLink, contentBlocks2Block2ButtonExternalLink, contentBlocks2Block3ButtonExternalLink } = data
    return (
        <div className='about-impact-wrap'>
            <div className='container'>
                <div className='row sm-text-center  heading-head-sec'>
                    <div className='col-md-4'>
                        <h2 className='heading-level-2 blue-color'>{contentBlocks2Title && parser(contentBlocks2Title)}</h2>
                    </div>
                    <div className='col-md-8'>
                        <p>{contentBlocks2Text && parser(contentBlocks2Text)}</p>
                    </div>
                </div>
                <div className='row impact-col-row-1'>
                    {contentBlocks2Blocks?.map((block, i) => (
                        <div className='col-md-4 tp-btm-space-col' key={i}>
                            <div className='about-col-bx light-blue-col-1'>
                                <div className='heading-level-2 blue-color'>
                                    {block.contentBlocks2BlockTitle}
                                </div>
                                <p>{block.contentBlocks2BlockText}</p>
                            </div>
                        </div>
                    ))}
                </div>
                <div className='row impact-col-row-1'>
                    <div className='col-md-8 tp-btm-space-col pink-bold-p'>
                        <div className='about-col-bx light-grey-bg'>
                            <div className='heading-level-3 black-color'>
                                {contentBlocks2Block1Title && parser(contentBlocks2Block1Title)}
                            </div>
                            <p>{contentBlocks2Block1Subtitle && parser(contentBlocks2Block1Subtitle)}</p>
                            <div className='partnership-text'>
                                {contentBlocks2Block1Text && parser(contentBlocks2Block1Text)}
                            </div>
                            {contentBlocks2Block1ButtonExternalLink ? (
                                <a href={contentBlocks2Block1ButtonExternalLink} className="btn blue-arrow-btn blue-text-arrow-btn">
                                    {contentBlocks2Block1ButtonText}
                                </a>
                            ) : contentBlocks2Block1ButtonLink ? (
                                <Link
                                    className='btn blue-arrow-btn blue-text-arrow-btn'
                                    to={contentBlocks2Block1ButtonLink.uri}
                                >
                                    {contentBlocks2Block1ButtonText}
                                </Link>
                            ) : null}
                        </div>
                    </div>
                    <div className='col-md-4 pink-bold-p text-center tp-btm-space-col'>
                        <div className='about-col-bx abt-district-col light-blue-col'>
                            <div>
                                <div className='heading-level-3 black-color'>
                                    {contentBlocks2Block2Title && parser(contentBlocks2Block2Title)}
                                </div>
                                <p>{contentBlocks2Block2Text && parser(contentBlocks2Block2Text)}</p>
                                {contentBlocks2Block2ButtonExternalLink ? (
                                    <a href={contentBlocks2Block2ButtonExternalLink} className="btn blue-arrow-btn blue-text-arrow-btn">
                                        {contentBlocks2Block2ButtonText}
                                    </a>
                                ) : contentBlocks2Block2ButtonLink ? (
                                    <Link
                                        className='btn blue-arrow-btn blue-text-arrow-btn'
                                        to={contentBlocks2Block2ButtonLink.uri}
                                    >
                                        {contentBlocks2Block2ButtonText}
                                    </Link>
                                ) : null}
                            </div>
                        </div>
                    </div>

                    <div className='col-md-6 tp-btm-space-col'>
                        <div className='about-col-bx abt-district-col light-grey-bg'>
                            <div>
                                <div className='heading-level-3 black-color'>
                                    {contentBlocks2Block3Title && parser(contentBlocks2Block3Title)}
                                </div>
                                <p>{contentBlocks2Block3Text && parser(contentBlocks2Block3Text)}</p>
                                {contentBlocks2Block3ButtonExternalLink ? (
                                    <a href={contentBlocks2Block3ButtonExternalLink} className="btn blue-arrow-btn blue-text-arrow-btn">
                                        {contentBlocks2Block3ButtonText}
                                    </a>
                                ) : contentBlocks2Block3ButtonLink ? (
                                    <Link
                                        className='btn blue-arrow-btn blue-text-arrow-btn'
                                        to={contentBlocks2Block3ButtonLink.url}
                                    >
                                        {contentBlocks2Block3ButtonText}
                                    </Link>
                                ) : null}
                            </div>
                        </div>
                    </div>

                    <div className='col-md-6 text-center tp-btm-space-col'>
                        <div className='about-col-bx light-grey-bg'>
                            <figure className='head-abt-icon'>
                                <StaticImage
                                    src='../../../images/testimonial-icon.png'
                                    alt='image'
                                />
                            </figure>
                            <p>
                                <strong>
                                    <em>{contentBlocks2Block4Text && parser(contentBlocks2Block4Text)}</em>
                                </strong>
                            </p>
                            <p>{contentBlocks2Block4Title && parser(contentBlocks2Block4Title)}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
